import {
  renderRowGaps,
  renderColumnGaps,
  renderMainLeftCell,
  renderMainRightCell,
  renderSoftLeftCell
} from '../helpers';

export const renderSummaryRowRight = (label, data) => {
  let rowString = `<tr>`;
  rowString += renderMainLeftCell(label);
  rowString += renderMainRightCell(data);
  rowString += `</tr>`;
  return rowString;
};

export const renderSummaryRowLeft = (label, data) => {
  let rowString = `<tr>`;
  rowString += renderMainLeftCell(label);
  rowString += renderMainLeftCell(data);
  rowString += `</tr>`;
  return rowString;
};

export const renderPriceAtNavRow = (priceAtNav, asOfDate) => {
  let rowString = `<tr>`;
  rowString += renderMainLeftCell('Price at NAV');
  rowString += renderMainRightCell(priceAtNav);
  rowString += renderColumnGaps(1);
  rowString += renderSoftLeftCell(`As of ${asOfDate} (updated daily)`);
  rowString += `</tr>`;
  return rowString;
};

export const summaryModule = rowData => {
  let summaryString;
  summaryString += renderSummaryRowRight(rowData['summary'].label, rowData['summary'].data);
  summaryString += renderSummaryRowRight(rowData['shareClass'].label, rowData['shareClass'].data);
  summaryString += renderSummaryRowLeft(rowData['fundDescription'].label, rowData['fundDescription'].data);
  summaryString += renderPriceAtNavRow(rowData['priceAtNav'].priceAtNav, rowData['priceAtNav'].asOfDate);
  summaryString += renderSummaryRowRight(rowData['fundAssets'].label, rowData['fundAssets'].data);
  summaryString += renderSummaryRowRight(rowData['portfolioManagers'].label, rowData['portfolioManagers'].data);
  summaryString += renderSummaryRowRight(rowData['expenseRatio'].label, rowData['expenseRatio'].data);
  summaryString += renderSummaryRowLeft(rowData['fundObjective'].label, rowData['fundObjective'].data);
  summaryString += renderRowGaps(2);
  return summaryString;
};
